export const quotes = (value: string): string => `“${value}”`;
